/** Preserva pagamentoId/pagamentosAntecipado ao clonar (array com props extras não copia no spread). */
const clonarFaturaFornecedorEstado = (faturaFornecedor) => {
    if (!faturaFornecedor) return {}

    if (Array.isArray(faturaFornecedor)) {
        const copia = [...faturaFornecedor]
        if (faturaFornecedor.pagamentoId) {
            copia.pagamentoId = [...faturaFornecedor.pagamentoId]
        }
        if (faturaFornecedor.pagamentosAntecipado) {
            copia.pagamentosAntecipado = [...faturaFornecedor.pagamentosAntecipado]
        }
        return copia
    }

    return {
        ...faturaFornecedor,
        pagamentoId: faturaFornecedor.pagamentoId ? [...faturaFornecedor.pagamentoId] : faturaFornecedor.pagamentoId,
        pagamentosAntecipado: faturaFornecedor.pagamentosAntecipado
            ? [...faturaFornecedor.pagamentosAntecipado]
            : faturaFornecedor.pagamentosAntecipado
    }
}

const INITIAL_STATE = {
    desconto: [],
    faturaFornecedor: {},
    faturasFornecedores: [],
    faturasFornecedoresCheckAll: false,
    faturasFornecedoresIdsSelecionadas: [],
    faturasFornecedoresSelecionadas: [],
    faturasFornecedoresChecked: [],
    faturasFornecedoresReservasCheckAll: false,
    faturasFornecedoresReservasIdsSelecionadas: [],
    faturasFornecedoresReservasSelecionadas: [],
    faturasFornecedoresReservasChecked: [],
    dadosFiltro: {
        id: '',
        dataDe: '',
        dataAte: '',
        status: [],
        fornecedor: { value: '', label: 'Todos' },
        categoria: { value: '', label: 'Todos' },
        segmento: { value: '', label: 'Todos' },
        motorista: { value: '', label: 'Todos' },
        clear: false
    },
    dadosFiltroAplicado: {
        id: '',
        dataDe: '',
        dataAte: '',
        status: [],
        fornecedor: { value: '', label: 'Todos' },
        categoria: { value: '', label: 'Todos' },
        segmento: { value: '', label: 'Todos' },
        motorista: { value: '', label: 'Todos' }
    },
    sortBy: 'id',
    sortDir: 'desc',
    indexAtual: null,
    totalPax: 0,
    totalValorNeto: 0,
    aReceber: 0,
    aPagar: 0,
    valorTotal: 0,
    currentPage: 1,
    lastPage: 1,
    total: 0
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {

        case 'FATURAS_FORNECEDOR_FETCHED':
            // Processar os pagamentos dos acertos dos fornecedores
            console.log('Dados recebidos do backend:', action.payload.faturas.data);
            
            const faturasProcessadas = action.payload.faturas.data.map(fatura => {
                const faturaCopy = { ...fatura };
                
                if (faturaCopy.fatura_acertos_fornecedor) {
                    faturaCopy.fatura_acertos_fornecedor = faturaCopy.fatura_acertos_fornecedor.map(acerto => {
                        const acertoCopy = { ...acerto };
                        
                        console.log('Acerto fornecedor:', acertoCopy.acerto_fornecedor);
                        console.log('Pagamentos:', acertoCopy.acerto_fornecedor?.acertoFornecedorPagamentos);
                        
                        // Calcular total pago excluindo pagamentos "FATURADO" (ID 1)
                        let totalPago = 0;
                        let totalFaturado = 0;
                        
                        if (acertoCopy.acerto_fornecedor?.acertoFornecedorPagamentos) {
                            acertoCopy.acerto_fornecedor.acertoFornecedorPagamentos.forEach(pagamento => {
                                console.log('Pagamento:', pagamento);
                                if (pagamento.pagamentoForma?.pag_id === 1) {
                                    // Pagamento FATURADO
                                    totalFaturado += Number(pagamento.valor || 0);
                                } else {
                                    // Outros tipos de pagamento
                                    totalPago += Number(pagamento.valor || 0);
                                }
                            });
                        }
                        
                        console.log('Total faturado:', totalFaturado);
                        console.log('Total pago:', totalPago);
                        
                        // Calcular valores para exibição
                        acertoCopy.acerto_fornecedor.credito = totalFaturado;
                        acertoCopy.acerto_fornecedor.valor_credito_debito = Number(acertoCopy.acerto_fornecedor.debito || 0) - totalFaturado;
                        
                        return acertoCopy;
                    });

                    // Exibe reservas/lançamentos na ordem crescente para facilitar leitura
                    faturaCopy.fatura_acertos_fornecedor.sort((a, b) => {
                        const dataA = new Date(a?.acerto_fornecedor?.data_adicionado || 0).getTime()
                        const dataB = new Date(b?.acerto_fornecedor?.data_adicionado || 0).getTime()
                        if (dataA !== dataB) return dataA - dataB
                        return Number(a?.acerto_fornecedor?.id || 0) - Number(b?.acerto_fornecedor?.id || 0)
                    })
                }
                
                return faturaCopy;
            });

            const faturasOrdenadas = [...faturasProcessadas].sort((a, b) => (b?.id ?? 0) - (a?.id ?? 0));

            return {
                ...state, 
                faturasFornecedores: faturasOrdenadas, 
                totalPax: action.totalProdutoPax, 
                totalValorNeto: action.totalProdutoNeto, 
                aReceber: action.aReceber,
                currentPage: action.payload.faturas.current_page || 1,
                lastPage: action.payload.faturas.last_page || 1,
                total: action.payload.faturas.total || 0
            }

        case 'FATURAS_FORNECEDOR_UNCHECK':
            return { ...state, faturasFornecedoresIdsSelecionadas: action.payload }


        case 'FATURAS_FORNECEDOR_CHECK': {

            const copyFaturas = [...state.faturasFornecedores]
            const faturasCopy = { ...copyFaturas[action.index] }
            faturasCopy.selecionado = action.value

            copyFaturas[action.index] = faturasCopy

            return { ...state, faturasFornecedores: copyFaturas }
        }

        case 'FATURAS_FORNECEDOR_CHECK_ALL':
            return { ...state, faturasFornecedoresCheckAll: !state.faturasFornecedoresCheckAll }

        case 'FATURA_FORNECEDOR_ATUALIZAR_STATUS': {
            const { faturaId, status } = action.payload
            const copyFaturas = [...state.faturasFornecedores]
            const index = copyFaturas.findIndex((f) => Number(f.id) === Number(faturaId))
            if (index === -1) return state
            const faturaCopy = { ...copyFaturas[index], status }
            copyFaturas[index] = faturaCopy
            return { ...state, faturasFornecedores: copyFaturas }
        }

        case 'FATURAS_FORNECEDOR_CHECK_FATURAS_CLEAR':
            return { ...state, faturasFornecedoresSelecionadas: [], faturasFornecedoresIdsSelecionadas: [] }

        case 'FATURAS_FORNECEDOR_RESERVAS_UNCHECK':
            return { ...state, faturasFornecedoresReservasIdsSelecionadas: action.payload }


        case 'FATURAS_FORNECEDOR_RESERVAS_CHECK': {

            const copyFaturas = [...state.faturasFornecedores]
            const acertoCopy = { ...copyFaturas[action.index] }
            const reservaCopy = { ...acertoCopy.fatura_acertos_fornecedor[action.indexReserva] }
            reservaCopy.selecionado = action.value

            acertoCopy.fatura_acertos_fornecedor[action.index] = reservaCopy
            copyFaturas[action.index] = acertoCopy

            return { ...state, faturasFornecedores: copyFaturas }
        }

        case 'FATURAS_FORNECEDOR_RESERVAS_CHECK_ALL':
            return { ...state, faturasFornecedoresCheckAll: !state.faturasFornecedoresCheckAll }


        case 'FATURAS_FORNECEDOR_RESERVAS_CHECK_FATURAS_CLEAR':
            return { ...state, faturasFornecedoresSelecionadas: [], faturasFornecedoresIdsSelecionadas: [] }

        case 'SELECIONAR_FATURAS_FORNECEDOR': {
            var novasFaturasIdsSelecionadas = [...state.faturasFornecedoresIdsSelecionadas]
            var novasFaturasSelecionadas = [...state.faturasFornecedoresSelecionadas]
            const indexSelect = novasFaturasIdsSelecionadas.indexOf(action.payload) // Verifica se o número já existe no array
            const indexFaturaSelect = novasFaturasIdsSelecionadas.indexOf(action.faturaFornecedor) // Verifica se o número já existe no array

            if (indexSelect === -1) {
                // Se não existir, adiciona o número ao array                           
                novasFaturasIdsSelecionadas.push(action.payload)
                novasFaturasSelecionadas.push(action.faturaFornecedor)
            } else {
                // Se existir, remove o número do array
                novasFaturasIdsSelecionadas.splice(indexSelect, 1)
                novasFaturasSelecionadas.splice(indexFaturaSelect, 1)
            }

            // console.log("novasFaturasSelecionadas: ", novasFaturasSelecionadas)
            return { ...state, faturasFornecedoresSelecionadas: novasFaturasSelecionadas, faturasFornecedoresIdsSelecionadas: novasFaturasIdsSelecionadas }

        }

        case 'SELECIONAR_FATURAS_RESERVA': {
            var novasFaturasIdsSelecionadas = [...state.faturasFornecedoresReservasIdsSelecionadas]
            var novasFaturasSelecionadas = [...state.faturasFornecedoresReservasSelecionadas]
            const indexSelect = novasFaturasIdsSelecionadas.indexOf(action.payload) // Verifica se o número já existe no array
            const indexFaturaSelect = novasFaturasIdsSelecionadas.indexOf(action.faturaFornecedor) // Verifica se o número já existe no array

            if (indexSelect === -1) {
                // Se não existir, adiciona o número ao array                           
                novasFaturasIdsSelecionadas.push(action.payload)
                novasFaturasSelecionadas.push(action.faturaFornecedor)
            } else {
                // Se existir, remove o número do array
                novasFaturasIdsSelecionadas.splice(indexSelect, 1)
                novasFaturasSelecionadas.splice(indexFaturaSelect, 1)
            }

            // console.log("novasFaturasSelecionadas: ", novasFaturasSelecionadas)
            return { ...state, faturasFornecedoresReservasSelecionadas: novasFaturasSelecionadas, faturasFornecedoresReservasIdsSelecionadas: novasFaturasIdsSelecionadas }

        }

        case 'FATURAS_FORNECEDOR_ABRIR_GRUPO': {
            const faturasFornecedores = [...state.faturasFornecedores]
            const index = action.index
            const atualIndex = action.indexAtual
            const teste = { ...faturasFornecedores[index] }

            if ((atualIndex) && (index != atualIndex)) {
                const faturaAtual = { ...faturasFornecedores[atualIndex] }
                faturaAtual.grupoAberto = false
                faturasFornecedores[atualIndex] = faturaAtual
            } else if ((atualIndex) || index >= 0) {
                const faturaAtual = { ...faturasFornecedores[atualIndex] }
                faturaAtual.grupoAberto = false
                faturasFornecedores[atualIndex] = faturaAtual

            }

            teste.grupoAberto = !teste.grupoAberto
            faturasFornecedores[index] = teste
            return { ...state, faturasFornecedores, indexAtual: index }
        }

        case 'FATURA_FORNECEDOR_GET_FATURAS': {
            let copyFatura = { ...action.faturaFornecedor }
            const ids = []
            let totalValor = 0

            copyFatura = action.payload
            copyFatura.pagamentosAntecipado = []

            const valorParaBR = (v) => {
                if (v == null || v === '') return ''
                const num = typeof v === 'number' ? v : parseFloat(String(v).replace(',', '.')) || 0
                return Number.isFinite(num) ? num.toFixed(2).replace('.', ',') : ''
            }

            for (const item of copyFatura) {
                ids.push(item.id)
            }

            const baseStorageUrl = `${process.env.REACT_APP_BACKEND_WEB || ''}storage/`

            for (const [index, faturaItem] of copyFatura.entries()) {
                if (faturaItem.pagamentos.length > 0) {
                    for (const item of faturaItem.pagamentos) {
                        console.log(item, 'bah')
                        const forma = item.forma || {}
                        const comprovantesArquivos = Array.isArray(item.comprovantes)
                            ? item.comprovantes.map((c) => ({
                                isExisting: true,
                                url: c.arquivo && !String(c.arquivo).startsWith('http') ? `${baseStorageUrl}${c.arquivo}` : c.arquivo,
                                name: String(c.arquivo || '').split('/').pop(),
                                // Trava o pagamento no modal quando já conferido pela tesouraria.
                                conferido: Boolean(c?.conferido),
                                dataConferencia: c?.data_conferencia ?? null,
                                // Devolvida ao salvar para o comprovante recriado manter a data de inserção original.
                                dataAdicionado: c?.data_adicionado ?? null
                            }))
                            : []

                        copyFatura.pagamentosAntecipado.push({
                            valor: valorParaBR(item.valor) || '0,00',
                            formaPagamento: {
                                value: forma.pag_id,
                                label: forma.pag_nome,
                                pag_idtipo: forma.pag_idtipo ?? forma?.tipo?.id ?? null,
                                pag_credito: forma.pag_credito ?? 'NAO',
                                pag_cash: forma.pag_cash ?? 'NAO',
                                pag_debito: forma.pag_debito ?? 'NAO'
                            },
                            fontePagamento: item.fonte ? { value: item.fonte.id, label: item.fonte.nome } : { value: null, label: null },
                            parcela: item.parcela ? { label: item.parcela.par_nome, value: item.parcela.par_id } : { label: '1X', value: 1 },
                            local: item.local ? item.local : "",
                            id: item.id,
                            comprovantesArquivos
                        })

                        totalValor += Number(item.valor)
                    }
                } else {
                    const valorInicialPagamento = Number(
                        faturaItem.valor_comissao ?? faturaItem.valor_a_receber ?? 0
                    )

                    copyFatura.pagamentosAntecipado.push({
                        valor: valorParaBR(valorInicialPagamento) || '0,00',
                        formaPagamento: { label: 'Selecione a forma de pagamento!', value: '' },
                        fontePagamento: { label: 'Selecione a fonte de pagamento!', value: '' },
                        parcela: { label: '1X', value: 1 },
                        local: "",
                        comprovantesArquivos: []
                    })

                    totalValor += valorInicialPagamento

                }


            }

            copyFatura.pagamentoId = ids

            return { ...state, faturaFornecedor: copyFatura, aPagar: action.totalNeto, valorTotal: parseFloat(totalValor).toFixed(2) }
        }

        case 'FATURA_FORNECEDOR_PAGAMENTOS_ANTECIPADOS_SET': {
            const cadastroCopy = clonarFaturaFornecedorEstado(state.faturaFornecedor)
            cadastroCopy.pagamentosAntecipado = action.payload
            return { ...state, faturaFornecedor: cadastroCopy }
        }

        case 'FATURA_FORNECEDOR_PAGAMENTO_CHANGE_FONTE_PAGAMENTOS_ANTECIPADOS': {
            const copyFatura = clonarFaturaFornecedorEstado(state.faturaFornecedor)
            const copyValor = [...copyFatura.pagamentosAntecipado]
            var rowCopy = { ...copyValor[action.index] }

            rowCopy['fontePagamento'] = action.payload
            copyValor[action.index] = rowCopy
            copyFatura.pagamentosAntecipado = copyValor

            return { ...state, faturaFornecedor: copyFatura }
        }

        case 'FATURA_FORNECEDOR_PAGAMENTO_ANTECIPADO_CHANGE_CAMPO': {
            const copyFatura = clonarFaturaFornecedorEstado(state.faturaFornecedor)
            const copyPagamentos = [...(copyFatura.pagamentosAntecipado || [])]
            const rowCopy = { ...copyPagamentos[action.index] }

            rowCopy[action.campo] = action.payload
            copyPagamentos[action.index] = rowCopy
            copyFatura.pagamentosAntecipado = copyPagamentos

            return { ...state, faturaFornecedor: copyFatura }
        }
        case 'FATURA_FORNECEDOR_PAGAMENTO_CHANGE_PAGAMENTOS_ANTECIPADOS': {
            const copyFatura = clonarFaturaFornecedorEstado(state.faturaFornecedor)
            const copyValor = [...copyFatura.pagamentosAntecipado]
            var rowCopy = { ...copyValor[action.index] }

            rowCopy['formaPagamento'] = action.payload
            copyValor[action.index] = rowCopy
            copyFatura.pagamentosAntecipado = copyValor

            return { ...state, faturaFornecedor: copyFatura }

        }

        case 'FATURA_FORNECEDOR_PAGAMENTO_ANTECIPADO_CHANGE_VALOR': {
            const copyFatura = clonarFaturaFornecedorEstado(state.faturaFornecedor)
            const copyValor = [...copyFatura.pagamentosAntecipado]
            var rowCopy = { ...copyValor[action.index] }

            rowCopy['valor'] = action.payload

            copyValor[action.index] = rowCopy
            copyFatura.pagamentosAntecipado = copyValor

            return { ...state, faturaFornecedor: copyFatura }
        }

        case 'FATURA_FORNECEDOR_PAGAMENTO_ANTECIPADO_CHANGE_PARCELA': {
            const copyFatura = clonarFaturaFornecedorEstado(state.faturaFornecedor)
            const copyValor = [...copyFatura.pagamentosAntecipado]
            var rowCopy = { ...copyValor[action.index] }

            rowCopy['parcela'] = action.payload
            copyValor[action.index] = rowCopy
            copyFatura.pagamentosAntecipado = copyValor

            return { ...state, faturaFornecedor: copyFatura }
        }

        case 'FATURA_FORNECEDOR_REMOVER_LINHA_PAGAMENTOS_ANTECIPADOS': {
            const copyFaturaFornecedor = clonarFaturaFornecedorEstado(state.faturaFornecedor)
            const copyPagamentosAntecipado = [...copyFaturaFornecedor.pagamentosAntecipado]
            copyPagamentosAntecipado.splice(action.index, 1)
            copyFaturaFornecedor.pagamentosAntecipado = copyPagamentosAntecipado
            return { ...state, faturaFornecedor: copyFaturaFornecedor }
            // var novosPagamentos = state.desconto.filter((pagamento, index) => index !== action.index);
            // return { ...state, faturaFornecedor: { ...state.faturaFornecedor, pagamentosAntecipado: novosPagamentos } };
        }

        case 'FATURA_FORNECEDOR_A_PAGAR_SET': {
            return { ...state, aPagar: parseFloat(action.payload).toFixed(2) }
        }

        case 'FATURA_FORNECEDOR_CALCULAR_VALOR_TOTAL': {
            const copyFaturaFornecedor = clonarFaturaFornecedorEstado(state.faturaFornecedor)
            let totalValor = 0

            for (const faturaItem of copyFaturaFornecedor.pagamentosAntecipado) {
                let value = 0

                if (isNaN(faturaItem.valor)) {
                    value = Number(faturaItem.valor.replace(',', '.'))
                } else {
                    value = Number(faturaItem.valor)
                }

                totalValor += value
            }

            return { ...state, valorTotal: parseFloat(totalValor).toFixed(2) }

        }

        case 'FATURA_FORNECEDOR_PAGAMENTO_ANTECIPADO_CHANGE_DESCONTO': {
            const copyDesconto = []

            if (action.payload) {
                for (const desconto of action.payload) {
                    copyDesconto.push({
                        id: desconto?.id ?? desconto?.desconto_id ?? null,
                        valorDesconto: desconto.valor,
                        descricaoDesconto: desconto?.motivo_descricao?.nome || desconto?.descricao || '',
                        motivoDesconto: desconto?.tipo_label || desconto?.tipo || '',
                        formaDesconto: desconto?.forma ?
                            { value: desconto?.forma, label: desconto?.forma == 'DEBITO' ? 'Débito' : 'Crédito' } :
                            { value: 0, label: '' },
                        fonteDesconto: desconto?.fontes ?
                            { value: desconto?.fontes.id, label: desconto?.fontes.nome } :
                            { value: 0, label: '' }
                    })
                    console.log(copyDesconto)
                }
            }

            return { ...state, desconto: copyDesconto }
        }

        case 'FATURA_FORNECEDOR_PAGAMENTO_CHANGE_DESCONTOS_INPUT': {
            const copyDesconto = [...state.desconto]

            if (action.name == 'valorDesconto') {
                let value = 0

                if (isNaN(action.payload)) {
                    value = Number(action.payload.replace(',', '.'))
                } else {
                    value = Number(action.payload)
                }

                copyDesconto[action.index][action.name] = value

            } else {

                copyDesconto[action.index][action.name] = action.payload
            }

            return { ...state, desconto: copyDesconto }

        }

        case 'FATURA_FORNECEDOR_DESCONTOS_SET': {
            let cadastroCopy = [...state.desconto]
            cadastroCopy = action.payload
            return { ...state, desconto: cadastroCopy }
        }

        case 'FATURAS_FORNECEDOR_DESCONTOS_CLEAN': {
            return { ...state, desconto: [] }
        }

        case 'FATURA_FORNECEDOR_REMOVER_LINHA_DESCONTOS': {
            const novosPagamentos = state.desconto.filter((pagamento, index) => index !== action.index)

            console.log(novosPagamentos, 'novosPagamentos')

            return { ...state, desconto: novosPagamentos }
        }

        case 'FATURA_FORNECEDOR_SET_FILTRO_CLEAR': {
            const dadosFiltroCopy = {
                id: '',
                dataDe: '',
                dataAte: '',
                status: [],
                fornecedor: { value: '', label: 'Todos' },
                categoria: { value: '', label: 'Todos' },
                segmento: { value: '', label: 'Todos' },
                motorista: { value: '', label: 'Todos' },
                clear: false
            }
            return { ...state, dadosFiltro: dadosFiltroCopy, dadosFiltroAplicado: { ...dadosFiltroCopy } }
        }

        case 'FATURA_FORNECEDOR_SET_FILTRO': {
            const dadosFiltroCopy = { ...state.dadosFiltro }
            dadosFiltroCopy[action.campo] = action.valor
            return { ...state, dadosFiltro: dadosFiltroCopy }
        }

        case 'FATURA_FORNECEDOR_SET_FILTRO_APLICADO': {
            const payload = action.payload || {}
            return {
                ...state,
                dadosFiltroAplicado: payload,
                // Mantém o formulário alinhado com os filtros aplicados (ex.: reload com query string).
                dadosFiltro: { ...state.dadosFiltro, ...payload }
            }
        }

        case 'FATURA_FORNECEDOR_SET_SORT': {
            const sortBy = action.sortBy || 'id'
            const sortDir = action.sortDir === 'asc' ? 'asc' : 'desc'
            return { ...state, sortBy, sortDir }
        }

        case 'FATURA_FORNECEDOR_SET_PAGE': {
            const next = Number(action.payload)
            return { ...state, currentPage: !isNaN(next) && next > 0 ? next : 1 }
        }

        case 'FATURA_FORNECEDOR_PAGAMENTO_LIMPAR': {
            return { ...state, faturaFornecedor: {} }
        }


        default:
            return state
    }
}